import {styled} from '@linaria/react';
import {List} from './List';

export const SimpleList = styled(List)`
  &&& {
    list-style: none;
    padding-left: 0;
    margin-top: 1em;
    margin-bottom: 1em;
  }
`;
